module.exports = __webpack_public_path__ + "img/shopping.cc4b73b1.svg";